import React from 'react';

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { createAssistantMcp } from 'api/assistants';
import { getMcps } from 'api/mcps';
import { useParams } from 'react-router-dom';
import SelectInput from 'components/Form/SelectInput';
import Button from 'components/Button';
import Popup from 'components/Popup';

export default function AssistantAddMCPPopup({
    visible,
    setVisible,
    present = [],
}) {

    const { assistantId } = useParams();
    const cache = useQueryClient();

    const { mutate: update } = useMutation({
        mutationKey: ['updateAssistant'],
        mutationFn: createAssistantMcp,
        onSuccess: () => {
            cache.invalidateQueries(['assistants', assistantId]);
            return setVisible(false);
        },
        onError: (error) => {
            console.error("Error updating assistant:", error);
        }
    });
    
    const { data: mcps } = useQuery({
        queryKey: ['mcps'],
        queryFn: async () => await getMcps({}),
    });

    const selectOptions = mcps?.map(mcp => {
        return {
            value: mcp._id,
            label: mcp.name
        }
    });

    function onSubmitHandler(formData) {
        return update({
            data: {
                mcp: formData.get('mcp')
            },
            id: assistantId
        });
    }

    return (
        <Popup
            visible={visible}
            setVisible={setVisible}
        >
            <form action={onSubmitHandler} className='flex flex-col gap-4'>
                {selectOptions &&
                    <SelectInput
                        label="Seleziona MCP"
                        name="mcp"
                        options={selectOptions?.filter(mcp => !present?.includes(mcp.value))}
                        required
                    />
                }

                <div className='flex justify-between gap-4 mt-6'>
                    <div onClick={() => setVisible(false)} className='hover:bg-verylight cursor-pointer px-4 py-3 text-sm rounded-sm'>
                        Annulla
                    </div>
                    <Button submit>Conferma</Button>
                </div>
            </form>
        </Popup>
    );
}